const WORDS = ["Fashion", "Music", "Holidays", "Cars", "Technology", "Future Tech", "Ideas", "Gaming", "Ink & Street"];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div data-testid="editorial-marquee" className="border-y border-white/10 py-5 overflow-hidden bg-obsidian select-none">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className={`font-display font-extrabold uppercase text-3xl sm:text-5xl tracking-tight px-6 ${i % 2 === 0 ? "text-porcelain" : "text-outline"}`}>
                  {w}
                </span>
                <span className="text-kinetic text-2xl sm:text-3xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
